import { v4 as uuidv4 } from 'uuid'
import { genPrompt } from '@/api/prompt'
import { genOssImage } from '@/utils/ossPath'
import { Message } from 'element-ui'
import { getLastUsedBaseUrl, cudaIndexNum } from '@/utils/comfyUiRequest'
import axios from 'axios'
import cuda from '@/utils/checkCuda'
import random from 'random'

import { OSS_ACCESS_KEY_ID, OSS_ACCESS_KEY_SECRET, BAIDU_TRANSLATE_API_KEY } from '@/utils/secretCrypto'
function handsrecover(imagePath, positive, progressCallback) {
  return new Promise((resolve, reject) => {
    const imageList = []
    const seed = Math.floor(Math.random() * 100000000000000)
    const filename = `["tmp-comfyui/${String(Date.now()) + String(random.int(1, 99999))}.png"]`
    const promptData = {
      2: {
        inputs: {
          samples: [
            '45',
            0
          ],
          vae: [
            '10',
            0
          ]
        },
        class_type: 'VAEDecode',
        _meta: {
          title: 'VAE Decode'
        }
      },
      9: {
        inputs: {
          text: [
            '41',
            0
          ],
          clip: [
            '37',
            0
          ]
        },
        class_type: 'CLIPTextEncode',
        _meta: {
          title: 'CLIP Text Encode (Prompt)'
        }
      },
      10: {
        inputs: {
          vae_name: 'FLUX1/ae.safetensors'
        },
        class_type: 'VAELoader',
        _meta: {
          title: 'Load VAE'
        }
      },
      13: {
        inputs: {
          model: [
            '38',
            0
          ]
        },
        class_type: 'DifferentialDiffusion',
        _meta: {
          title: 'Differential Diffusion'
        }
      },
      22: {
        inputs: {
          text: positive
        },
        class_type: 'Nodepad_啊程记事本',
        _meta: {
          title: 'Nodepad_啊程记事本'
        }
      },
      23: {
        inputs: {
          filename_prefix: 'ComfyUI',
          images: [
            '2',
            0
          ]
        },
        class_type: 'SaveImage',
        _meta: {
          title: '图生图'
        }
      },
      29: {
        inputs: {
          image: 'example.png'
        },
        class_type: 'LoadImage',
        _meta: {
          title: 'Load Image'
        }
      },
      30: {
        inputs: {
          pixels: [
            '43',
            0
          ],
          vae: [
            '10',
            0
          ]
        },
        class_type: 'VAEEncode',
        _meta: {
          title: 'VAE Encode'
        }
      },
      32: {
        inputs: {
          amount: 1,
          samples: [
            '30',
            0
          ]
        },
        class_type: 'RepeatLatentBatch',
        _meta: {
          title: 'Repeat Latent Batch'
        }
      },
      37: {
        inputs: {
          clip_name1: 'clip_l.safetensors',
          clip_name2: 't5xxl_fp8_e4m3fn_scaled.safetensors',
          type: 'flux',
          device: 'default'
        },
        class_type: 'DualCLIPLoader',
        _meta: {
          title: 'DualCLIPLoader'
        }
      },
      38: {
        inputs: {
          unet_name: '小红书风格模型丨日常旅拍，极致真实_小红书自然真实FP8模型.safetensors',
          weight_dtype: 'fp8_e4m3fn'
        },
        class_type: 'UNETLoader',
        _meta: {
          title: 'Load Diffusion Model'
        }
      },
      40: {
        inputs: {
          text: positive,
          translate_from: 'zh',
          translate_to: 'en',
          APIID: '20250612002379955',
          APIKEY: BAIDU_TRANSLATE_API_KEY
        },
        class_type: 'AC_百度翻译',
        _meta: {
          title: 'AC_百度翻译'
        }
      },
      41: {
        inputs: {
          boolean: true,
          on_true: [
            '40',
            0
          ],
          on_false: [
            '22',
            0
          ]
        },
        class_type: 'easy ifElse',
        _meta: {
          title: 'If else'
        }
      },
      42: {
        inputs: {
          image_url: imagePath
        },
        class_type: 'AC_从URL加载图像',
        _meta: {
          title: 'AC_从URL加载图像'
        }
      },
      43: {
        inputs: {
          boolean: false,
          on_true: [
            '29',
            0
          ],
          on_false: [
            '42',
            0
          ]
        },
        class_type: 'easy ifElse',
        _meta: {
          title: 'If else'
        }
      },
      44: {
        inputs: {
          filename: filename,
          access_key_id: OSS_ACCESS_KEY_ID,
          access_key_secret: OSS_ACCESS_KEY_SECRET,
          security_token: '',
          bucket_name: 'mj-comfy-ui',
          endpoint: 'oss-cn-shenzhen.aliyuncs.com',
          image: [
            '2',
            0
          ]
        },
        class_type: 'AC_Oss上传图像',
        _meta: {
          title: 'AC_Oss上传图像'
        }
      },
      45: {
        inputs: {
          seed: seed,
          steps: 20,
          cfg: 1,
          sampler_name: 'euler',
          scheduler: 'simple',
          denoise: 0.15,
          model: [
            '13',
            0
          ],
          positive: [
            '46',
            0
          ],
          negative: [
            '48',
            0
          ],
          latent_image: [
            '32',
            0
          ]
        },
        class_type: 'KSampler',
        _meta: {
          title: 'KSampler'
        }
      },
      46: {
        inputs: {
          guidance: 3.5,
          conditioning: [
            '9',
            0
          ]
        },
        class_type: 'FluxGuidance',
        _meta: {
          title: 'FluxGuidance'
        }
      },
      47: {
        inputs: {
          text: '',
          clip: [
            '37',
            0
          ]
        },
        class_type: 'CLIPTextEncode',
        _meta: {
          title: 'CLIP Text Encode (Prompt)'
        }
      },
      48: {
        inputs: {
          conditioning: [
            '47',
            0
          ]
        },
        class_type: 'ConditioningZeroOut',
        _meta: {
          title: 'ConditioningZeroOut'
        }
      }
    }
    const clientId = uuidv4()
    const data = {
      prompt: promptData,
      client_id: clientId
    }
    // 发送 Prompt 请求
    const sendPromptRequest = async () => {
      try {
        console.log('get prompt response', data)
        return genPrompt(data)
      } catch (error) {
        console.error('发送作图请求失败：', error)
      }
    }

    const fetchImageFilename = async (promptId) => {
      try {
        // 直接使用该实例请求历史记录
        const historyRequest = axios.create({
          baseURL: getLastUsedBaseUrl(),
          timeout: 5000,
          headers: {
            'Content-Type': 'application/json'
          }
        })

        const response = await historyRequest.get(`/history/${promptId}`)
        const promptInfo = response.data[promptId]
        const promptIndex = 2 // prompt信息的下标
        const inputIndex = 44 // prompt信息组件名的下标
        if (promptInfo.status.status_str === 'success') {
          const tmp = JSON.parse(promptInfo.prompt[promptIndex][inputIndex].inputs.filename)
          imageList.push(genOssImage(tmp[0]))
        } else {
          console.error('获取历史记录失败，状态码：', response.status)
        }
        return imageList
      } catch (error) {
        console.error('获取图像文件名失败：', error)
      }
    }

    const listenToProgress = (promptId) => {
      const ws = new WebSocket(`${getLastUsedBaseUrl()}/ws?clientId=${clientId}`)
      const wsTimeout = setTimeout(() => {
        Message.warning('网络连接超时,请重新尝试!')
        ws.close()
      }, 2000)

      ws.onopen = () => {
        console.log('提交服务器开始生成...')
        clearTimeout(wsTimeout)
      }
      ws.onmessage = async (event) => {
        clearTimeout(wsTimeout)
        const data = event.data
        if (typeof data === 'string') {
          try {
            const msg = JSON.parse(event.data)
            if (msg.type === 'executing') {
              const data = msg.data
              if (data.node === null && data.prompt_id === promptId) {
                ws.close()
                const images = await fetchImageFilename(promptId)
                // 返回对象
                const obj = {
                  images: images,
                  status: false
                }
                resolve(obj)
              }
            } else if (msg.type === 'progress') {
              const value = msg.data.value
              const max = msg.data.max
              const current = (value / max * 100).toFixed(2)
              if (progressCallback && typeof progressCallback === 'function') {
                progressCallback(current)
              }
            }
          } catch (error) {
            console.log('获取结果失败，请重试')
          }
        }
      }
      ws.onerror = (error) => {
        reject(error)
      }
      ws.onclose = async () => {
        try {
          const index = cudaIndexNum()
          await cuda.changeCudaCurrentStatus(index, 'leisure')
        } catch (error) { console.log(error) }
      }
    }

    (async () => {
      const result = await sendPromptRequest()
      if (result && result.prompt_id) {
        listenToProgress(result.prompt_id)
      }
    })()
  })
}

export {
  handsrecover
}
